import { PropsWithChildren } from 'react'
import { motion } from 'motion/react'
import { cn } from '@/utils'

interface Props extends PropsWithChildren {
	className?: string
	nowrap?: boolean
	delay?: number
	speed?: number
}

export const Text = ({
	className,
	nowrap,
	delay = 0,
	speed = 0.2,
	children
}: Props) => {
	const words = children?.toString().split(' ') || []

	return (
		<div className={cn('inline-flex flex-wrap', nowrap && 'flex-nowrap')}>
			{words.map((word, index) => (
				<span key={index} className="inline-flex">
					{word.split('').map((letter, i) => (
						<motion.span
							key={i}
							className={className}
							initial={{ opacity: 0, scale: 0, x: 40 }}
							animate={{ opacity: 1, scale: 1, x: 0 }}
							transition={{
								delay: delay + (index * 0.3 + i * 0.05),
								duration: speed,
								ease: 'easeOut'
							}}
						>
							{letter}
						</motion.span>
					))}

					{index < words.length - 1 && (
						<motion.span
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{
								delay: (index + 1) * 0.3,
								duration: 0.2
							}}
						>
							&nbsp;
						</motion.span>
					)}
				</span>
			))}
		</div>
	)
}
